import React from 'react'
import NavButton from '../nav-button'
import useViewport from '../../../hooks/use-viewport'

const NavIconButton = ({
    icon,
    children,
    size = 25,
    ...props
}) => {
    const { isMobile } = useViewport()
    const Icon = icon
    return (
        <NavButton {...props}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: isMobile ? '0.6em' : '1em' }}>
                <Icon size={isMobile ? size / 2 : size} /> 
                {children}
            </div>
        </NavButton>
    )
}

export default NavIconButton